import React from 'react';
import LongArrow from 'products/global/assets/img/home/long_arrow.svg';
import { th } from 'style/theme';
import FadeUpWrapper from 'components/FadeUpWrapper';
import ProductCard from './components/ProductCard';
import { Title, Line, ProductsContainer, ArrowLeft, Spacer, Launching } from './styled';

const Products = () => {
  return (
    <>
      <FadeUpWrapper delay={100} damping={50} mass={2} yDelta={40}>
        <Title>Our products</Title>
      </FadeUpWrapper>
      <Line />
      <ProductsContainer>
        <ArrowLeft>
          <img src={LongArrow} alt="arrow" />
        </ArrowLeft>
        <ProductCard
          title="Nomad Insurance"
          description="A travel and medical incident insurance built specifically for digital nomads. It can be purchased while already abroad, covers home trip visits and operates like a monthly subscription."
          callToAction={{ text: 'Get insured', link: '/nomad-insurance/signup' }}
          primaryColor={th('colors.turquoise')}
          secondaryColor={th('colors.yellow')}
        />
        <ProductCard
          title="Remote Health"
          description="Remote Health insurance is a fully fledged health insurance for remote teams and entrepreneurs. It gives global companies a truly flexible solution that no other insurance company offers."
          callToAction={{
            text: 'Get your team insured',
            link: `${process.env.REACT_APP_URL}/remote-health`,
            external: true
          }}
          primaryColor={th('colors.indigo')}
          secondaryColor={th('colors.green')}
        />
        <ProductCard
          noGlow
          title="Remote Retirement"
          description="A retirement product for globally distributed teams that works in any country to help ensure your employees’ futures."
          primaryColor={th('colors.regentGray')}
        >
          <Launching>COMING SOON</Launching>
        </ProductCard>
        <Spacer>&nbsp;</Spacer>
      </ProductsContainer>
    </>
  );
};

export default Products;
